// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";

// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import roleService from "../../../Services/roleService";
// import staffService from "../../../Services/staffService";

// const AddEditStaff = () => {
//   const [staffData, setDoctorData] = useState({
//     full_name: "",
//     role: "",
//     date_of_birth: "",
//     gender: "",
//     contact_number: "",
//     email: "",
//     address: "",
//     qualification: "",
//     hire_date: "",
//     salary: 0.00,
//     cnic: "",
//     status: "1"
//   });

//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [roleData, setRoleData] = useState([]);

//   useEffect(() => {
//     const getRoles = async () => {
//       try {
//         const response = await roleService.fetchAllRoles();
//         console.log(response); // Log the response to confirm the structure
//         setRoleData(response.roles); // Access the patients array within response
//       } catch (error) {
//         toast.error("Error fetching Doctors");
//       }
//     };
//     getRoles();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setDoctorData({ ...staffData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await staffService.update(id, staffData)
//         toast.success("Doctor updated successfully!"); // Success message
//       } else {
//         await staffService.create(staffData);
//          // Success message
//       }
//       navigate("/admin/hospital/doctor");
//       toast.success("Doctor added successfully!"); // Redirect after submission
//     } catch (error) {
//       toast.error("Error saving Doctor."); // Error message
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center font-[700] text-[20px]">
//         {id ? "Edit Staff" : "Add Staff"}
//       </h1>
//       <Divider />
//       <div>
//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Name"
//               variant="outlined"
//               fullWidth
//               name="full_name"
//               value={staffData.full_name}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Phone No."
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="contact_number"
//               value={staffData.contact_number}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>            
//             <TextField
//               label="CNIC"
//               variant="outlined"
//               fullWidth
//               name="cnic"
//               value={staffData.cnic}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//         <div style={{ width: "33%" }}>
//             <TextField
//               label="Date of Birth"
//               variant="outlined"
//               fullWidth
//               type="date"
//               name="date_of_birth"
//               value={staffData.date_of_birth}
//               onChange={handleChange}
//               required
//               InputLabelProps={{
//                 shrink: true,
//               }}
//             />
//           </div>
          
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Email"
//               variant="outlined"
//               fullWidth
//               name="email"
//               value={staffData.email}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Qualification"
//               variant="outlined"
//               fullWidth
//               name="qualification"
//               value={staffData.qualification}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Address"
//               variant="outlined"
//               fullWidth
//               name="address"
//               value={staffData.address}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Pay"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="salary"
//               value={staffData.salary}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//         <div style={{ width: "33%" }}>
//             <TextField
//               label="Date of Appointment"
//               variant="outlined"
//               fullWidth
//               type="date"
//               name="hire_date"
//               value={staffData.hire_date}
//               onChange={handleChange}
//               required
//               InputLabelProps={{
//                 shrink: true,
//               }}
//             />
//           </div>
//           <div  style={{ marginLeft: 20, width: "50%" }}>
//             <FormControl fullWidth>
//               <InputLabel>Assigned Role</InputLabel>
//               <Select
//                 label="Assigned Role"
//                 name="role"
//                 value={staffData.role} // Set the selected doctor's ID
//                 onChange={handleChange}
//                 required
//               >
//                 {roleData.map((roles) => (
//                   <MenuItem key={roles.role_id} value={roles.role_id}>
//                     {roles.role_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </div>

//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <FormControl fullWidth>
//               <InputLabel>Gender</InputLabel>
//               <Select
//                 label="Gender"
//                 name="gender"
//                 value={staffData.gender}
//                 onChange={handleChange}
//                 required
//               >
//                 <MenuItem value="Male">Male</MenuItem>
//                 <MenuItem value="Female">Female</MenuItem>
//                 <MenuItem value="Other">Other</MenuItem>
//               </Select>
//             </FormControl>
//           </div>
//         </div>

//         <Grid container style={{ justifyContent: "center", marginTop: "30px" }}>
//           <Button
//             variant="contained"
//             type="submit"
//             color="primary"
//             size="large"
//             className="!bg-gray-700 !text-white"
//             style={{ borderRadius: "10px" }}
//           >
//             Save and Continue
//           </Button>
//         </Grid>
//       </div>
//     </form>
//   );
// };

// export default AddEditStaff;

import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import roleService from "../../../Services/roleService";
import staffService from "../../../Services/staffService";

const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <input
      {...props}
      className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-200 focus:ring-2 focus:ring-orange-100"
    />
  </div>
);

const SelectField = ({ label, name, value, onChange, required, children }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <select
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-200 focus:ring-2 focus:ring-orange-100 appearance-none"
    >
      <option value="" disabled>Select {label}</option>
      {children}
    </select>
  </div>
);

const ValidatedField = ({ label, value, maxLength, onChange, placeholder, hint }) => {
  const isComplete = value.length === maxLength;
  const isPartial = value.length > 0 && value.length < maxLength;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <label className="text-[12px] font-[500] text-gray-500">{label}</label>
        {isPartial && (
          <span className="text-[11px] text-red-400">{maxLength - value.length} digits remaining</span>
        )}
        {isComplete && (
          <span className="text-[11px] text-green-500 font-[500]">✓ Valid {hint}</span>
        )}
      </div>
      <input
        type="text"
        value={value}
        onChange={onChange}
        required
        maxLength={maxLength}
        placeholder={placeholder}
        className={`w-full px-3 py-2 text-[13px] text-gray-800 bg-white border rounded-lg outline-none transition-colors
          hover:border-orange-200 focus:ring-2 focus:ring-orange-100
          ${isComplete
            ? "border-green-400 focus:border-green-400"
            : isPartial
            ? "border-red-300 focus:border-orange-200"
            : "border-gray-200 focus:border-orange-200"
          }`}
      />
    </div>
  );
};

const AddEditStaff = () => {
  const [staffData, setDoctorData] = useState({
    full_name: "",
    role: "",
    date_of_birth: "",
    gender: "",
    contact_number: "",
    email: "",
    address: "",
    qualification: "",
    hire_date: "",
    salary: 0.00,
    cnic: "",
    status: "1",
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const [roleData, setRoleData] = useState([]);

  useEffect(() => {
    const getRoles = async () => {
      try {
        const response = await roleService.fetchAllRoles();
        setRoleData(response.roles);
      } catch (error) {
        toast.error("Error fetching Roles");
      }
    };
    getRoles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDoctorData({ ...staffData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await staffService.update(id, staffData);
        toast.success("Staff updated successfully!");
      } else {
        await staffService.create(staffData);
        toast.success("Staff added successfully!");
      }
      navigate("/staff");
    } catch (error) {
      toast.error("Error saving staff.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-7xl">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* Header */}
          <div className="bg-gray-800 px-8 py-5">
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              {id ? "Edit Staff" : "New Staff Registration"}
            </h1>
            <p className="text-gray-400 text-[12px] mt-0.5">
              {id ? "Update the staff member's details below" : "Fill in the details below to register a new staff member"}
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="px-8 py-6">

            <SectionLabel>Personal Information</SectionLabel>
            <div className="grid grid-cols-3 gap-4">
              <InputField
                label="Full Name"
                type="text"
                name="full_name"
                value={staffData.full_name}
                onChange={handleChange}
                required
                placeholder="Enter full name"
              />
              <ValidatedField
                label="Phone Number"
                value={staffData.contact_number}
                maxLength={11}
                placeholder="e.g. 03001234567"
                hint="number"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "").slice(0, 11);
                  setDoctorData({ ...staffData, contact_number: val });
                }}
              />
              <ValidatedField
                label="CNIC"
                value={staffData.cnic}
                maxLength={13}
                placeholder="13 digits, numbers only"
                hint="CNIC"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "").slice(0, 13);
                  setDoctorData({ ...staffData, cnic: val });
                }}
              />
            </div>

            <div className="grid grid-cols-3 gap-4 mt-4">
              <InputField
                label="Date of Birth"
                type="date"
                name="date_of_birth"
                value={staffData.date_of_birth}
                onChange={handleChange}
                required
              />
              <InputField
                label="Email"
                type="email"
                name="email"
                value={staffData.email}
                onChange={handleChange}
                required
                placeholder="Enter email address"
              />
              <InputField
                label="Qualification"
                type="text"
                name="qualification"
                value={staffData.qualification}
                onChange={handleChange}
                required
                placeholder="Enter qualification"
              />
            </div>

            <SectionLabel>Employment Details</SectionLabel>
            <div className="grid grid-cols-2 gap-4">
              <InputField
                label="Address"
                type="text"
                name="address"
                value={staffData.address}
                onChange={handleChange}
                required
                placeholder="Enter residential address"
              />
              <InputField
                label="Salary (Pay)"
                type="number"
                name="salary"
                value={staffData.salary}
                onChange={handleChange}
                required
                placeholder="Enter salary amount"
              />
            </div>

            <div className="grid grid-cols-3 gap-4 mt-4">
              <InputField
                label="Date of Appointment"
                type="date"
                name="hire_date"
                value={staffData.hire_date}
                onChange={handleChange}
                required
              />
              <SelectField
                label="Assigned Role"
                name="role"
                value={staffData.role}
                onChange={handleChange}
                required
              >
                {roleData.map((r) => (
                  <option key={r.role_id} value={r.role_id}>
                    {r.role_name}
                  </option>
                ))}
              </SelectField>
              <SelectField
                label="Gender"
                name="gender"
                value={staffData.gender}
                onChange={handleChange}
                required
              >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </SelectField>
            </div>

            {/* Footer */}
            <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
              >
                ← Cancel
              </button>
              <button
                type="submit"
                className="bg-gray-800 hover:bg-gray-700 transition-colors text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
              >
                {id ? "Update Staff" : "Save & Continue →"}
              </button>
            </div>

          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          {id ? "Changes will be saved immediately." : "Staff member will be available for assignment after saving."}
        </p>
      </div>
    </div>
  );
};

export default AddEditStaff;